"use strict";
exports.__esModule = true;
var adjust_fitted_points_1 = require("./adjust-fitted-points");
var metalog_1 = require("./metalog");
var basic_chart_component_1 = require("../../../../basic-component/basic-chart.component");
var accounting = require('accounting');
var smartorg;
(function (smartorg) {
    var r6;
    (function (r6) {
        var acts;
        (function (acts) {
            var metalog;
            (function (metalog) {
                var AdjustFittedPoints = adjust_fitted_points_1["default"].AdjustFittedPoints;
                var MetalogChartMaker = /** @class */ (function () {
                    function MetalogChartMaker(inputData, shadowInputData, shadowNodeName, nodeName, colors, showTooltip, decimals, timestamp) {
                        // this.clickflag = true;
                        this.inputData = inputData;
                        this.shadowInputData = shadowInputData;
                        this.nodeName = nodeName;
                        this.shadowNodeName = shadowNodeName;
                        this.colors = colors;
                        this.metaLogPresent = "MetaLogOutputs" in inputData;
                        this.showTooltip = showTooltip;
                        this.decimals = decimals;
                        this.timestamp = timestamp;
                        this.optionalSeries = [];
                    }
                    MetalogChartMaker.prototype.initialize = function (selectedTerm, failureBranch, selectedTermShadow) {
                        this.selectedTerm = selectedTerm;
                        this.color = this.colors.mainColor;
                        if (failureBranch) {
                            this.arrayOfFailureBranchPoints = failureBranch.arrayOfFailureBranchPoints;
                        }
                        if (this.shadowInputData) {
                            this.shadowColor = this.colors.shadowColor;
                        }
                        if (this.metaLogPresent) {
                            this.metaLogPoints = this.makePoints(this.inputData, selectedTerm, failureBranch);
                            if (this.shadowInputData) {
                                this.shadowMetaLogPoints = this.makePoints(this.shadowInputData, selectedTermShadow, failureBranch);
                            }
                        }
                    };
                    MetalogChartMaker.prototype.findYByX = function (val, points) {
                        for (var _i = 0, points_1 = points; _i < points_1.length; _i++) {
                            var _a = points_1[_i], cdfPoint = _a.cdfPoint, pdfPoint = _a.pdfPoint;
                            if (cdfPoint.x >= val) {
                                var x = cdfPoint.x, y = cdfPoint.y;
                                return [x, y];
                            }
                        }
                        return null;
                    };
                    MetalogChartMaker.prototype.addDot = function (title, value, symbol, color, isShadow) {
                        if (typeof value === 'undefined' || value === null) {
                            return null;
                        }
                        var points = isShadow ? this.shadowMetaLogPoints : this.metaLogPoints;
                        var nodeName = isShadow ? this.shadowNodeName : this.nodeName;
                        var point = this.findYByX(value, points);
                        var a = {
                            type: 'scatter',
                            name: title + (" (" + nodeName + ")"),
                            color: color,
                            marker: {
                                symbol: symbol,
                                lineWidth: 4,
                                lineColor: color,
                                states: {
                                    hover: {
                                        lineColor: color,
                                        lineWidth: 4
                                    }
                                }
                            },
                            data: [point]
                        };
                        this.optionalSeries.push(a);
                        return point;
                    };
                    MetalogChartMaker.prototype.cdfPointsFrom = function (metaLogPoints) {
                        return metaLogPoints.map(function (item) {
                            return item.cdfPoint;
                        });
                    };
                    MetalogChartMaker.prototype.metaLogPointsFrom = function (cdfPoints) {
                        return cdfPoints.map(function (item) {
                            var metaLogPoint = { cdfPoint: item, pdfPoint: {} };
                            return metaLogPoint;
                        });
                    };
                    MetalogChartMaker.prototype.makePoints = function (data, selectedTerm, failureBranch) {
                        var probabilityOfFailure = 0, value = 0;
                        var stages = [];
                        var coefficientsContainer = new metalog_1.MetaLogPanel(data.MetaLogOutputs.Panel).selectedFeasiblePanel(selectedTerm);
                        var coefficientOfSelectedFeasiblePanel = typeof coefficientsContainer != 'undefined' ? coefficientsContainer.Coefficients : [];
                        var metaLog = new metalog_1.MetaLog(coefficientOfSelectedFeasiblePanel);
                        var metaLogData = [];
                        for (var y = 0; y < 1; y += 0.001) {
                            var x = metaLog.cdfInverse(y);
                            var pdf = metaLog.pdf(y);
                            if (!isNaN(x) && x != -Infinity) {
                                var cdfPoint = {
                                    x: x,
                                    y: y
                                };
                                var pdfPoint = { x: x, y: pdf };
                                metaLogData.push({ cdfPoint: cdfPoint, pdfPoint: pdfPoint });
                            }
                        }
                        // Add PDF y-value to the fitted points
                        data.MetaLogOutputs.FittedPoints.PDFy =
                            data.MetaLogOutputs.FittedPoints.Probabilities.map(function (eachValue) {
                                return metaLog.pdf(eachValue);
                            });
                        data.MetaLogOutputs.BaseCaseCDF = this.baseCaseValue(data);
                        data.MetaLogOutputs.BaseCasePDF = this.baseCaseValue(data);
                        data.MetaLogOutputs.BaseCasePDF[0][1] = metaLog.pdf(data.MetaLogOutputs.BaseCaseCDF[0][1]);
                        if (failureBranch) {
                            probabilityOfFailure = failureBranch.probability;
                            value = failureBranch.value;
                            stages = failureBranch.arrayOfFailureBranchPoints;
                            var cdfPointsFromSuccessCurve = this.cdfPointsFrom(metaLogData);
                            metaLogData = this.metaLogPointsFrom(AdjustFittedPoints.makeFailureBranchStagesData(cdfPointsFromSuccessCurve, stages));
                            return metaLogData;
                        }
                        else
                            return metaLogData;
                    };
                    MetalogChartMaker.prototype.getDate = function (timestamp) {
                        if (timestamp === void 0) { timestamp = null; }
                        return (0, basic_chart_component_1.getDate)(this.timestamp);
                    };
                    MetalogChartMaker.prototype.setCrossSymbol = function () {
                        Highcharts.SVGRenderer.prototype.symbols.cross = function (x, y, w, h) {
                            return ['M', x, y, 'L', x + w, y + h, 'M', x + w, y, 'L', x, y + h, 'z'];
                        };
                        if (Highcharts.VMLRenderer) {
                            Highcharts.VMLRenderer.prototype.symbols.cross = Highcharts.SVGRenderer.prototype.symbols.cross;
                        }
                    };
                    MetalogChartMaker.prototype.drawCDF = function (showFittedPoints, hasCorrectCoefficients) {
                        var series = [];
                        var chartMaker = this;
                        if (showFittedPoints) {
                            if (hasCorrectCoefficients) {
                                series.push({
                                    name: 'Points ' + '(' + chartMaker.nodeName + ')',
                                    type: 'scatter',
                                    marker: {
                                        symbol: 'circle'
                                    },
                                    color: chartMaker.colors.mainColor,
                                    data: chartMaker.fittedPointsOnCDF(chartMaker.inputData)
                                });
                            }
                            series.push({
                                name: 'Base Case Value ' + '(' + chartMaker.nodeName + ')',
                                type: 'scatter',
                                color: 'red',
                                marker: {
                                    radius: 5,
                                    symbol: 'square',
                                    lineColor: 'black',
                                    fillColor: 'red'
                                },
                                data: chartMaker.inputData.MetaLogOutputs.BaseCaseCDF
                            });
                        }
                        if (hasCorrectCoefficients) {
                            series.push({
                                name: 'CDF ' + '(' + chartMaker.nodeName + ')',
                                color: chartMaker.colors.mainColor,
                                data: chartMaker.curveToCDFPoints(chartMaker.metaLogPoints)
                            });
                        }
                        if (chartMaker.shadowInputData) {
                            if (showFittedPoints) {
                                if (hasCorrectCoefficients) {
                                    series.push({
                                        name: 'Points ' + '(' + chartMaker.shadowNodeName + ')',
                                        type: 'scatter',
                                        color: chartMaker.colors.shadowColor,
                                        marker: {
                                            symbol: 'circle'
                                        },
                                        data: chartMaker.fittedPointsOnCDF(chartMaker.shadowInputData)
                                    });
                                }
                                series.push({
                                    name: 'Base Case Value ' + '(' + chartMaker.shadowNodeName + ')',
                                    type: 'scatter',
                                    color: 'red',
                                    marker: {
                                        radius: 5,
                                        symbol: 'square',
                                        lineColor: 'black',
                                        fillColor: 'red'
                                    },
                                    data: chartMaker.shadowInputData.MetaLogOutputs.BaseCaseCDF
                                });
                            }
                            if (hasCorrectCoefficients) {
                                series.push({
                                    name: 'CDF ' + '(' + chartMaker.shadowNodeName + ')',
                                    color: chartMaker.colors.shadowColor,
                                    data: chartMaker.curveToCDFPoints(chartMaker.shadowMetaLogPoints)
                                });
                            }
                        }
                        var chartOptions = this.makeMetalogChartOptions(series);
                        this.setCrossSymbol();
                        this.chart = new Highcharts.Chart(chartOptions, function (chart) {
                            chart.renderer.text(chartMaker.getDate(chartMaker.timestamp), 420, 400).css({
                                color: '#939294',
                                fontSize: '10px'
                            }).add();
                        });
                    };
                    MetalogChartMaker.prototype.drawPDF = function (showFittedPoints, hasCorrectCoefficients) {
                        var chartMaker = this;
                        var pdfOptions = chartMaker.pdfChartOptions();
                        pdfOptions["series"] = [];
                        var series = pdfOptions.series;
                        if (hasCorrectCoefficients) {
                            series.push({
                                name: 'Metalog PDF (' + chartMaker.nodeName + ')',
                                color: chartMaker.colors.mainColor,
                                data: chartMaker.curveToPDFPoints(chartMaker.metaLogPoints)
                            });
                        }
                        if (showFittedPoints) {
                            if (hasCorrectCoefficients) {
                                series.push({
                                    name: 'Points' + '(' + chartMaker.nodeName + ')',
                                    type: 'scatter',
                                    marker: {
                                        symbol: 'circle'
                                    },
                                    color: chartMaker.colors.mainColor,
                                    data: chartMaker.fittedPointsOnPDF(chartMaker.inputData)
                                });
                            }
                            series.push({
                                name: 'Base Case Value' + '(' + chartMaker.nodeName + ')',
                                type: 'scatter',
                                color: chartMaker.colors.mainColor,
                                marker: {
                                    radius: 5,
                                    symbol: 'square',
                                    lineColor: 'black',
                                    fillColor: chartMaker.colors.mainColor
                                },
                                data: chartMaker.inputData.MetaLogOutputs.BaseCasePDF
                            });
                        }
                        if (chartMaker.shadowInputData) {
                            if (hasCorrectCoefficients) {
                                series.push({
                                    name: 'Metalog PDF (' + chartMaker.shadowNodeName + ')',
                                    color: chartMaker.colors.shadowColor,
                                    data: chartMaker.curveToPDFPoints(chartMaker.shadowMetaLogPoints)
                                });
                            }
                            if (showFittedPoints) {
                                series.push({
                                    name: 'Points' + '(' + chartMaker.nodeName + ')',
                                    type: 'scatter',
                                    marker: {
                                        symbol: 'circle'
                                    },
                                    color: chartMaker.colors.shadowColor,
                                    data: chartMaker.fittedPointsOnPDF(chartMaker.shadowInputData)
                                });
                                series.push({
                                    name: 'Base Case Value' + '(' + chartMaker.nodeName + ')',
                                    type: 'scatter',
                                    color: chartMaker.colors.mainColor,
                                    marker: {
                                        radius: 5,
                                        symbol: 'square',
                                        lineColor: 'black',
                                        fillColor: chartMaker.colors.shadowColor
                                    },
                                    data: chartMaker.shadowInputData.MetaLogOutputs.BaseCasePDF
                                });
                            }
                        }
                        this.setCrossSymbol();
                        this.chart = new Highcharts.Chart(pdfOptions, function (chart) {
                            chart.renderer.text(chartMaker.getDate(chartMaker.timestamp), 420, 400).css({
                                color: '#939294',
                                fontSize: '10px'
                            }).add();
                        });
                    };
                    MetalogChartMaker.prototype.fittedPointsOnCDF = function (data) {
                        var fittedpointsData = [];
                        fittedpointsData = data.MetaLogOutputs.FittedPoints.Values.map(function (value, i) {
                            var point = new Array();
                            point.push(value);
                            point.push(data.MetaLogOutputs.FittedPoints.Probabilities[i]);
                            return point;
                        });
                        if (this.arrayOfFailureBranchPoints) {
                            var successCurveData = AdjustFittedPoints.formatFittedPointsFrom(fittedpointsData);
                            fittedpointsData = AdjustFittedPoints.fittedPointsFrom(AdjustFittedPoints.makeFailureBranchStagesData(successCurveData, this.arrayOfFailureBranchPoints));
                        }
                        return fittedpointsData;
                    };
                    MetalogChartMaker.prototype.fittedPointsOnPDF = function (data) {
                        var fittedpointsData = [];
                        fittedpointsData = data.MetaLogOutputs.FittedPoints.Values.map(function (value, i) {
                            var point = new Array();
                            point.push(value);
                            point.push(data.MetaLogOutputs.FittedPoints.PDFy[i]);
                            return point;
                        });
                        if (this.arrayOfFailureBranchPoints) {
                            var successCurveData = AdjustFittedPoints.formatFittedPointsFrom(fittedpointsData);
                            fittedpointsData = AdjustFittedPoints.fittedPointsFrom(AdjustFittedPoints.makeFailureBranchStagesData(successCurveData, this.arrayOfFailureBranchPoints));
                        }
                        return fittedpointsData;
                    };
                    MetalogChartMaker.prototype.curveToCDFPoints = function (points) {
                        return points.map(function (point) {
                            return [point.cdfPoint.x, point.cdfPoint.y];
                        });
                    };
                    MetalogChartMaker.prototype.curveToPDFPoints = function (points) {
                        return points.map(function (point) {
                            return [point.pdfPoint.x, point.pdfPoint.y];
                        });
                    };
                    MetalogChartMaker.prototype.baseCaseValue = function (inputData) {
                        var data = inputData.Table[0].Data[4];
                        var dataset = [];
                        var fittedPointsValue = this.fittedPointsOnCDF(inputData);
                        for (var j = 0; j < fittedPointsValue.length; j++) {
                            dataset[j] = fittedPointsValue[j][0];
                        }
                        var baseCaseValue = data;
                        var fittedPointV = dataset;
                        var baseCaseValueTemp = Math.round(baseCaseValue * 10000) / 10000;
                        for (var i = 0; i < fittedPointV.length; i++) {
                            fittedPointV[i] = Math.round(fittedPointV[i] * 10000) / 10000;
                        }
                        var indexOfBCV = fittedPointV.indexOf(baseCaseValueTemp);
                        var baseCaseValuePro = fittedPointsValue[indexOfBCV][1];
                        if (this.arrayOfFailureBranchPoints) {
                            var tempData = this.fittedPointsOnCDF(this.inputData);
                            for (var i = 0; i < tempData.length; i++) {
                                if (Math.round(tempData[i][0] * 10000) / 10000 === baseCaseValueTemp) {
                                    baseCaseValuePro = tempData[i][1];
                                }
                            }
                        }
                        return [[baseCaseValue, baseCaseValuePro]];
                    };
                    MetalogChartMaker.prototype.pdfChartOptions = function () {
                        var tooltipPointFormat = 'Value: {point.x:.' + this.decimals + 'f} PDF(y): {point.y:.' + this.decimals + 'f}';
                        return {
                            chart: {
                                type: 'spline',
                                inverted: false,
                                zoomType: 'xy',
                                renderTo: 'metalogChartContainer'
                            },
                            credits: {
                                enabled: false
                            },
                            title: {
                                text: 'Probability Density Function'
                            },
                            subtitle: {
                                text: 'Using ' + this.selectedTerm + ' Term Fit'
                            },
                            xAxis: {
                                reversed: false,
                                title: {
                                    enabled: true,
                                    text: this.inputData.Display + ' (' + this.inputData.Units + ')'
                                },
                                labels: {
                                    formatter: function () {
                                        return this.value;
                                    }
                                },
                                maxPadding: 0.05,
                                showLastLabel: true,
                                crosshair: true
                            },
                            yAxis: {
                                title: {
                                    text: "PDF(y)"
                                },
                                labels: { enabled: false },
                                crosshair: true
                            },
                            legend: {
                                enabled: true
                            },
                            tooltip: {
                                enabled: this.showTooltip,
                                headerFormat: '<b>{series.name}</b><br/>',
                                pointFormat: tooltipPointFormat
                            },
                            plotOptions: {
                                series: {}
                            }
                        };
                    };
                    MetalogChartMaker.prototype.getFirstPoint = function () {
                        var a = this.curveToCDFPoints(this.metaLogPoints);
                        var output = a[0][0];
                        if (this.shadowMetaLogPoints) {
                            var b = this.curveToCDFPoints(this.shadowMetaLogPoints);
                            if (b[0][0] < output) {
                                output = b[0][0];
                            }
                        }
                        return output;
                    };
                    MetalogChartMaker.prototype.makeMetalogChartOptions = function (series) {
                        var tooltipPointFormat = 'Value: {point.x:.' + this.decimals + 'f} Probability: {point.y:.' + this.decimals + 'f}';
                        var additional = this.optionalSeries || [];
                        return {
                            chart: {
                                type: 'spline',
                                zoomType: 'xy',
                                inverted: false,
                                renderTo: 'metalogChartContainer'
                            },
                            credits: {
                                enabled: false
                            },
                            title: {
                                text: 'Cumulative Distribution Function'
                            },
                            subtitle: {
                                text: 'Using ' + this.selectedTerm + ' Term Fit'
                            },
                            xAxis: {
                                min: this.getFirstPoint() > 0 ? 0 : undefined,
                                reversed: false,
                                title: {
                                    enabled: true,
                                    text: this.inputData.Display + ' (' + this.inputData.Units + ')'
                                },
                                labels: {
                                    formatter: function () {
                                        return this.value;
                                    }
                                },
                                maxPadding: 0.05,
                                showLastLabel: true,
                                crosshair: true,
                                plotLines: [{
                                        color: '#ccd6eb',
                                        width: 1,
                                        value: 0
                                    }]
                            },
                            yAxis: {
                                max: 1,
                                title: {
                                    text: 'Probability'
                                },
                                labels: {
                                    formatter: function () {
                                        return this.value * 100 + '%';
                                    }
                                },
                                lineWidth: 0,
                                crosshair: true
                            },
                            legend: {
                                enabled: true
                            },
                            tooltip: {
                                enabled: this.showTooltip,
                                headerFormat: '<b>{series.name}</b><br/>',
                                pointFormat: tooltipPointFormat
                            },
                            series: series.concat(additional)
                        };
                    };
                    return MetalogChartMaker;
                }());
                metalog.MetalogChartMaker = MetalogChartMaker;
                function round(num) {
                    return Math.round(num * 100) / 100;
                }
            })(metalog = acts.metalog || (acts.metalog = {}));
        })(acts = r6.acts || (r6.acts = {}));
    })(r6 = smartorg.r6 || (smartorg.r6 = {}));
})(smartorg || (smartorg = {}));
exports["default"] = smartorg.r6.acts.metalog;
//# sourceMappingURL=metalog-chart-maker.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/metalog/app/js/logic/metalog-chart-maker.js